import CompanyInformation from './CompanyInformation';
import JoinOrganization from './JoinOrganization';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { matchOrg } from 'src/features/user/utils';

const CompanyWrapper = () => {
  const foundOrganization = useSelector((state: RootState) => state.user.foundOrganization);

  const finishedMatchingOrganization = useSelector((state: RootState) => state.user.finishedMatchingOrganization);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!finishedMatchingOrganization) {
      dispatch(matchOrg());
    }
  }, []);

  const renderComponent = () => {
    if (foundOrganization.hasData === null) {
      return (
        <div
          style={{
            backgroundColor: '#0000005e',
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.25rem',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress sx={{ color: '#FFF' }} size={50} />
          <Typography sx={{ marginTop: '0.9375rem', fontSize: '1.25rem', color: '#FFF' }}>
            Loading data... Please wait!
          </Typography>
        </div>
      );
    }

    if (foundOrganization.hasData === true) {
      return <JoinOrganization organization={foundOrganization} />;
    } else {
      return <CompanyInformation />;
    }
  };

  return <>{renderComponent()}</>;
};

export default CompanyWrapper;
